/* Flickity slider/carousel */
import Flickity from 'flickity';

/* Mobile menu toggle */
const header = document.querySelector('.header');
const overlay = document.querySelector('.overlay');
const hamburger = document.querySelectorAll('.hamburger');

for (var i = 0; i < hamburger.length; i++) {
  hamburger[i].addEventListener('click', function(event) {
    header.classList.toggle('header--active');
    overlay.classList.toggle('overlay--active');

    if (window.innerWidth > 540) {
      this.classList.toggle('hamburger--active');
    }
  });
}

/* Slideshow (Flickity) */
const slideshow = document.getElementsByClassName('slideshow'); 

if ( slideshow.length ) {
  const flkty = new Flickity('.slideshow', {
    lazyLoad: 1,
    wrapAround: true,
    autoPlay: 5000,
    setGallerySize: false,
    pageDots: false
  }).focus();
}

/* Project slideshow (Flickity) */
const project_slideshow = document.getElementsByClassName('project-slideshow__slides'); 

if ( project_slideshow.length ) {
  const flkty = new Flickity('.project-slideshow__slides', {
    lazyLoad: 1,
    autoPlay: 5000,
    setGallerySize: false,
    pageDots: false,
    watchCSS: true
  }).focus();
}
